import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Viser from 'viser-vue'
import ElementUI from 'element-ui'
import AFTableColumn from 'af-table-column' // 表格列宽自适应组件
import VueStorage from 'vue-ls'
import VueClipboard from 'vue-clipboard2'
import 'element-ui/lib/theme-chalk/index.css'
import GlobalComponents from '@/components'
import ZDrawer from './package/drawer'
import ZDivider from './package/divider'
import ZBackTop from './package/back-top'
import ZMessage from './package/z-message'
import ZTable from './package/z-table'
import ZAffix from './package/affix'
import 'font-awesome/css/font-awesome.css'

import bootstrap from '@/core/bootstrap'
import PermissionHelper from '@/utils/helper/permission'
import config from '@/config/default-settings'
import axios from './api/request'
import key from './config/key-value'
import utils from './utils'
import dayjs from 'dayjs'
import * as apecUtils from 'apec-fe-utils'
import '@/permission'
import '@/utils/filter'
import '@/utils/directive'

import './style/index.scss'
import './registerServiceWorker'

Vue.use(ElementUI)
Vue.use(Viser)

Vue.use(GlobalComponents)
Vue.use(ZDrawer)
Vue.use(ZDivider)
Vue.use(ZBackTop)
Vue.use(ZTable)
Vue.use(ZAffix)

Vue.use(VueStorage, config.storageOptions)
Vue.use(VueClipboard)
Vue.use(PermissionHelper)
Vue.use(ZMessage)
Vue.use(AFTableColumn)

Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.$key = key
Vue.prototype.$utils = utils
Vue.prototype.$apecUtils = apecUtils
Vue.prototype.$dayjs = dayjs

Vue.filter('thousandMark', utils.thousandMark) // 千分符
// test
// 类型状态过滤器，要保证引用keyFilter时component和filterKey与keyValue.js中的值一致
Vue.filter('keyFilter', function (value, component, filterKey, obj, oParam) {
  let result = value
  // let params = ''
  if (obj) {
    // 传后台数组数据进来。直接使用。oParam是对应接口的key和value名称
    obj.map(function (item) {
      if (item[oParam.oKey] === value) {
        result = item[oParam.oValue]
      }
    })
  } else {
    if (!key[component]) {
      console.log('未识别组件名 ' + component)
    } else if (!key[component][filterKey]) {
      console.log('未识别键名 ' + filterKey)
    } else {
      key[component][filterKey].map(function (item) {
        if (item.id === value) {
          result = item.name
        }
      })
    }
  }
  return result // 没返回其他信息，params属性就形同虚设了
})

Vue.prototype.filters = {
  keyFilter: Vue.filter('keyFilter'),
}

new Vue({
  router,
  store,
  created () {
    bootstrap()
  },
  render: h => h(App)
}).$mount('#app')
